/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-10 16:22:10
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo} from "src/types/base";
import { defaultNullValue } from 'src/config';
export declare namespace ParamsLogDOI {

	export interface RowDataI {
		
	}

	export interface QueryRowDataParamsI extends PageDo {
		keyword?: string
	}

}
export default class ParamsLogApi {
	/**
	 * 查询列表
	 * @param {ParamsLogDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: ParamsLogDOI.QueryRowDataParamsI):Promise<ResultPageDo<ParamsLogDOI.RowDataI[]>> {
		return Api.post('/monitor/select/parameter_log', {
            parameter_type: defaultNullValue,
            start_time: defaultNullValue,
            end_time: defaultNullValue,
            component: '',
            ...params
        })
	}

    static async exportAll(params: ParamsLogDOI.QueryRowDataParamsI):Promise<Result<{download_url: string}>> {
		return Api.post('/monitor/condition/parameter_log/export',{
            parameter_type: defaultNullValue,
            start_time: defaultNullValue,
            end_time: defaultNullValue,
            component: '',
            ...params
        })
    }
}